@if (isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
} @else {
  <div>
    <my-ibox boxTitle="Widgets">
      <div class="my-ibox-content">
        <p>{{'Widgets are small webpages that can be embedded in a Matrix room. Here you can configure which widgets Dimension will offer to users.' | translate}}</p>

        <table class="table table-striped table-condensed table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>{{'Description' | translate}}</th>
              <th class="text-center">{{'Actions' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            @for (widget of widgets; track widget) {
              <tr>
                <td>{{ widget.displayName | translate }}</td>
                <td>{{ widget.description | translate }}</td>
                <td class="text-right">
                  @if ((widget.isEnabled && hasConfiguration(widget))) {
                    <span class="editButton" (click)="editWidget(widget)" (keydown.enter)="editWidget(widget)">
                      <i class="fa fa-pencil-alt"></i>
                    </span>
                  }
                  <ui-switch [checked]="widget.isEnabled" size="small" [disabled]="isUpdating"
                  (change)="toggleWidget(widget)"></ui-switch>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </my-ibox>
  </div>
}
